import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
const BottomSheetPageIdContext = /*#__PURE__*/ React.createContext(null);
export const useBottomSheetPageId = ()=>useContext(BottomSheetPageIdContext);
export const BottomSheetPageIdProvider = (param)=>{
    let { children, value } = param;
    return /*#__PURE__*/ _jsx(BottomSheetPageIdContext.Provider, {
        value: value,
        children: children
    });
};
